import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/styles';
import {
  Button,
  Dialog,
  Typography,
  colors,
  TextField,
  IconButton,
  useMediaQuery
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(1, 0)
  },
  actions: {
    backgroundColor: colors.grey[100],
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end'
  },
  startButton: {
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  },
  inputPadding: {
    padding: theme.spacing(0, 1)
  },
  description: {
    flexGrow: 1,
    alignItems: 'flex-start'
  }
}));

const initValues = { name: '', description: '' };

const Modal = props => {
  const { open, onClose, onSubmit, className } = props;
  const theme = useTheme();
  const classes = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [values, setValues] = useState(initValues);

  const handleChange = (name) => ({ target }) => {
    setValues(values => ({ ...values, [name]: target.value }))
  }

  const handleClose = () => {
    onClose();
    setValues(initValues);
  }

  return (
    <Dialog
      classes={{ paper: clsx(classes.root, className) }}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="xs"
      onClose={onClose}
      open={Boolean(open)}
    >
      <div className={classes.header}>
        <Typography
          variant="h3"
        >
          Create Repository
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.inputPadding}>
        <TextField
          autoFocus
          fullWidth
          label="Name"
          margin="dense"
          onChange={handleChange('name')}
          placeholder="Name"
          value={values.name}
          variant="outlined"
        />
      </div>
      <div className={classes.inputPadding}>
        <TextField
          fullWidth
          label="Description"
          margin="normal"
          onChange={handleChange('description')}
          placeholder="Description"
          value={values.description}
          variant="outlined"
        />
      </div>
      <div className={classes.actions}>
        <Button
          color="primary"
          endIcon={<AddIcon />}
          onClick={() => onSubmit({ ...values, folderID: open }, handleClose)}
          variant="contained"
        >
          Create
        </Button>
      </div>
    </Dialog >
  );
};

Modal.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  open: PropTypes.any
};

export default Modal;
